import { SERVICE_NAME } from "@/config/serviceNames";
import { requests } from ".";

const ClientPortalService = {
  getPortalSettingsByDomain: (url: string) =>
    requests(SERVICE_NAME.CLIENT_PORTAL_API).get(url),
  removeDomainFromPortalSettingsByLocationId: (url: string) =>
    requests(SERVICE_NAME.CLIENT_PORTAL_API).put(url, {customDomain: ''}),
  deleteArchiveDomain: (locationId: string, domainName: string) =>
    requests(SERVICE_NAME.CLIENT_PORTAL_API).delete(`/domain/${locationId}/delete?domain=${domainName}`),
};

export default ClientPortalService;